import { IPDirection } from './enums';

export const convertDirectionToBackend = (direction: IPDirection): string => {
    return direction.toLowerCase();
};

export const isTCPOrUDPAllService = (serviceName: string, specialServices: string[]): boolean => {
    return specialServices.includes(serviceName);
};
